import { Store, Smartphone, CreditCard, QrCode, Mail, Upload, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { resizeImage } from "@/lib/branding";

const Btn = ({ active, onClick, icon: Icon, label, sub, id }) => (
  <button type="button" onClick={onClick} data-testid={id}
    className={`h-16 rounded-xl flex flex-col items-center justify-center gap-1 text-sm font-medium border transition-colors ${active ? "bg-[#B91C1C] text-white border-[#B91C1C] shadow-md" : "bg-white border-slate-200"}`}>
    <Icon className="w-5 h-5" />{label}
    {sub && <span className="text-[10px] leading-none">{sub}</span>}
  </button>
);

function QrBox({ shop, proof, setProof }) {
  const qrSrc = shop.qr_image.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${shop.qr_image}` : shop.qr_image;
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    try { setProof(await resizeImage(file, 1000, "image/jpeg")); } catch (err) { toast.error(err.message); }
  };
  return (
    <div className="mt-3 rounded-2xl border bg-white p-4 text-center" data-testid="qr-pay-box">
      <p className="text-sm font-semibold">{shop.qr_label || "Scan QR untuk bayar"}</p>
      <img src={qrSrc} alt="QR bayaran" className="mx-auto mt-2 w-56 h-56 object-contain" data-testid="qr-pay-image" />
      <a href={qrSrc} download="qr-bayaran" className="text-xs text-[#B91C1C] underline" data-testid="qr-pay-download">Simpan gambar QR</a>
      <label className={`mt-3 flex items-center justify-center gap-2 h-11 rounded-xl border-2 border-dashed cursor-pointer text-sm font-semibold ${proof ? "border-green-600 text-green-700 bg-green-50" : "border-slate-300 text-slate-600"}`}>
        {proof ? <CheckCircle2 className="w-4 h-4" /> : <Upload className="w-4 h-4" />}{proof ? "Bukti dimuat naik (tukar)" : "Muat naik bukti bayaran *"}
        <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid="qr-proof-upload" />
      </label>
      {proof && <img src={proof} alt="Bukti" className="mx-auto mt-2 max-h-40 rounded-lg" data-testid="qr-proof-preview" />}
    </div>
  );
}

export function PaymentPicker({ shop, pay, setPay, direct, setDirect, email, setEmail, proof, setProof, Field }) {
  const both = shop.qr_payment && shop.online_payment;
  return (
    <>
      <h2 className="font-display font-bold text-base mt-5 mb-3">Cara Bayaran</h2>
      <div className="grid grid-cols-2 gap-3">
        <Btn id="pay-cash" active={pay === "tunai"} onClick={() => setPay("tunai")} icon={Store} label="Bayar di Kedai" sub="Tunai / kaunter" />
        <Btn id="pay-direct" active={pay === "terus"} onClick={() => setPay("terus")} icon={Smartphone} label="Bayar Terus" sub={both ? "QR / FPX" : shop.qr_payment ? "Scan QR" : "FPX / Kad"} />
      </div>
      {pay === "terus" && both && (
        <div className="mt-3 grid grid-cols-2 gap-2 rounded-xl bg-slate-100 p-1 text-xs font-semibold">
          {[["qr", "Scan QR", QrCode], ["online", "FPX / Kad", CreditCard]].map(([k, l, I]) => (
            <button key={k} type="button" onClick={() => setDirect(k)} data-testid={`pay-direct-${k}`}
              className={`flex items-center justify-center gap-1 rounded-lg py-2 ${direct === k ? "bg-white text-[#B91C1C] shadow-sm" : "text-slate-500"}`}><I className="w-4 h-4" />{l}</button>
          ))}
        </div>
      )}
      {pay === "terus" && direct === "qr" && <QrBox shop={shop} proof={proof} setProof={setProof} />}
      {pay === "terus" && direct === "online" && (
        <div className="mt-3">
          <Field icon={Mail} label="Emel (untuk resit bayaran) *">
            <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="customer-email-input" inputMode="email" placeholder="nama@email.com" className="w-full outline-none text-sm font-medium bg-transparent" />
          </Field>
        </div>
      )}
    </>
  );
}
